import _ from "react";
import i from "classnames";
import './Image2.css';const n = "Image-module__imageTop___OTVmN", c = "Image-module__contain___fZs22", g = "Image-module__imageLeft___CyJp6", e = {
  imageTop: n,
  contain: c,
  imageLeft: g
}, s = ({ src: m, alt: t, position: a = "top", fit: o = "fill" }) => /* @__PURE__ */ _.createElement(
  "img",
  {
    className: i([
      a === "top" && e.imageTop,
      a === "left" && e.imageLeft,
      o === "contain" && e.contain
    ]),
    src: m,
    alt: t
  }
);
s.displayName = "Image";
export {
  s as I
};
